import { Component, Input } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { ChartConfiguration, ChartData, ChartEvent, ChartType } from "chart.js";
import { ToastrService } from "ngx-toastr";
import { filter } from "rxjs";
import { User } from "src/app/shareModule/models/user.model";
import { CustomerService } from "src/app/shareModule/services/customer.service";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { AppState } from "src/app/shareModule/states/app.state";
import { selectUser } from "src/app/shareModule/states/user-details";
declare const google: any;

@Component({
  selector: "app-biz-owner-popup",
  templateUrl: "./biz-owner-popup.component.html",
  styleUrls: ["./biz-owner-popup.component.scss"],
})
export class BizOwnerPopupComponent {
  @Input() inputId: number;
  public postalCode: string = "";
  public geocoder: any;
  public map: any;
  lat: number = 1.3521;
  lng: number = 103.8198;
  public radarChartLabels: string[] = [
    "Account Age",
    "No of Supporters",
    "Avg Level of Supporters",
    // 'Number of Orders',
    "No of Conversations",
    "Special Stats",
  ];
  public loading = false;
  public chartPopup: boolean = false;
  public radarChartData: ChartData<"radar"> = {
    labels: this.radarChartLabels,
    datasets: [{ data: [0, 0, 0, 0, 0], label: "" }],
  };
  public radarChartOptions: ChartConfiguration["options"] = {
    responsive: true,
    aspectRatio: 1,
    layout: {
      padding: 0,
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  public radarChartType: ChartType = "radar";
  public profile: any = {
    certificates: [],
    appUserSupports: [],
  };

  constructor(public local: LocalServiceService, private customerService: CustomerService, private store: Store<AppState>, private toastr: ToastrService,) {
    this.initMap();
  }

  ngOnInit(): void {
    this.getProfileInfo(this.inputId);
  }

  initMap(): void {
    setTimeout(() => {
      if (document.getElementById("map")) {

        this.map = new google.maps.Map(document.getElementById("map"), {
          center: { lat: this.lat, lng: this.lng },
          zoom: 12,
        });

        this.geocoder = new google.maps.Geocoder();
      }

      // if (this.postalCode != "") this.geocodePostalCode();
    }, 100);
  }

  public get createdString(): string {
    if (!this.profile.created) {
      return "Loading..."
    }
    return (new Date(this.profile.created * 1000)).toLocaleString()

  }

  private checkSupport() {

    return (
      this.loggedInUserProfile?.appUserSupports?.some(
        (row: any) => row.member_id == this.profile?.id
      )
    );
  }
  private loggedInUserProfile? = null;

  private isLogin = false;
  public handleSupportSeller() {
    if (!this.isLogin) {
      this.toastr.error('Please Login First!');
      return;
    }
    this.local
      .confirm({
        title: 'Support',
        text: `Do you wish to ${this.profile.isSupport ? 'unsupport' : 'support'} this business?`,
        icon: 'info',
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.customerService
            .addMemberSupport({
              businessId: this.profile.id,
              type: 'community',
            })
            .subscribe({
              next: (response: any) => {

                this.profile.isSupport = !this.profile.isSupport

              },
              error: (e) => {
                this.toastr.error(e.error.message);
              },
            });
        } else {
          this.toastr.info('Support cancelled');
        }
      });
  }

  public getProfileInfo(code: any) {
    this.store.pipe(select(selectUser)).pipe(filter(user => !!user)).subscribe((r: User) => {
      this.loggedInUserProfile = structuredClone(r || {});
      this.isLogin = !!r;
      this.checkSupport();
    });
    this.customerService.getProfileInfo(code, false, true).subscribe((response: any) => {
      this.profile = response.body;
      this.profile.certificates = this.profile?.certificates.filter((row: any) => row.role != "" && row.role != null);

      this.profile.certified = JSON.parse(this.profile.certified);
      //this.profile.created = this.convertDate(this.profile.created);
      this.profile.isSupport = this.checkSupport();

      this.postalCode = this.profile.postalCode;
      this.loading = false;
    });
  }
}
